// import { injectReducer } from 'store/reducers'
import { injectSagas } from 'store/sagas'
import SplashRoute from './routes/Splash'
import FocusToolsHubRoute from './routes/FocusToolsHub'
import GridToolRoute from './routes/GridTool'
import ResultsRoute from './routes/Results'
import HealthAndHappinessTool from './routes/HealthAndHappinessTool'
import MoneyTool from './routes/MoneyTool'
import DecisionTool from './routes/DecisionTool'

export const reducerKey = 'discovery'

export default (store) => ({

  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Discovery = require('./containers/DiscoveryContainer').default
      //const reducer = require('./modules/reducer').default // moved reducer to be a synchronously loaded reducer in /store/reducers.js
      const sagas = require('./modules/sagas').sagas

      /*  Add the reducer to the store on key 'discovery'  */
      //injectReducer(store, { key: reducerKey, reducer })
      injectSagas(store, { key: 'discovery', sagas })

      /*  Return getComponent   */
      cb(null, Discovery)

    /* Webpack named bundle   */
    }, 'Discovery')
  },

  indexRoute: { onEnter: (nextState, replace) => replace('/splash') },

  childRoutes: [
    SplashRoute(store),
    FocusToolsHubRoute(store),
    GridToolRoute(store),
    ResultsRoute(store),
    HealthAndHappinessTool(store),
    MoneyTool(store),
    DecisionTool(store)
  ]
})



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/routes/Discovery/index.js
 **/